import {clone} from '~/utils/helpers'

export const touristToUpdateUserRQ = ({
    prefix = null,
    firstName = null,
    lastName = null,
    birthdate = null,
    citizenshipId = null,
    email = null,
    phone = null,
}) => ({
    prefix,
    firstName,
    lastName,
    birthdate,
    citizenshipId,
    email,
    contactPhone: phone || null,
})

/**
 * Note: UpdateUserRQ same with UpdateCRMPersonRQ
 */
export const userInfoToUpdateUserRQ = (
    {
        prefix = null,
        firstName = null,
        firstNameLocalized = null,
        lastName = null,
        lastNameLocalized = null,
        birthdate = null,
        citizenshipId = null,
        email = null,
        contactPhone = null,
    },
    isUseLocalized = false
) => {
    const result = {
        prefix,
        birthdate,
        citizenshipId,
        email,
        contactPhone: contactPhone || null,
    }
    if (!isUseLocalized) {
        result.firstName = firstName || firstNameLocalized
        result.lastName = lastName || lastNameLocalized
        return result
    }
    result.firstNameLocalized = firstNameLocalized
    result.lastNameLocalized = lastNameLocalized
    return result
}

export const corpTouristToUpdateUserRQ = (
    {prefix = null, birthdate = null, citizenshipId = null, email = null, phone = null},
    {firstNameLocalized = {}, lastNameLocalized = {}}
) => ({
    prefix,
    firstNameLocalized,
    lastNameLocalized,
    birthdate,
    citizenshipId,
    email,
    contactPhone: phone || null,
})

export const userGetToPutTransformer = user => {
    const rq = clone(user)
    rq.messenger = rq.icq
    delete rq.icq
    delete rq.companyId
    delete rq.externalPersonId
    delete rq.cityName
    delete rq.companyName
    delete rq.passports
    delete rq.bonusCards
    delete rq.citizenshipName
    delete rq.addressLine
    if (rq.department?.id) {
        rq.departmentId = rq.department.id
        delete rq.department
    }

    return rq
}

export const privetClientGetToPutTransformer = user => {
    const rq = clone(user)
    delete rq.personId
    delete rq.login
    delete rq.countryName
    delete rq.cityName
    delete rq.externalId
    delete rq.passports
    delete rq.balance
    delete rq.totalLoyaltyPoints
    delete rq.firstOrderDate
    delete rq.lastOrderDate
    delete rq.balanceCurrency
    delete rq.receiveMarketingEmail
    delete rq.registrationDate
    delete rq.reservationsNumber
    delete rq.referralLevel

    return rq
}
